import { createFileRoute } from '@tanstack/react-router';
import { OrderAttachmentsView } from '@components/pages/OrderView/components/OrderAttachmentsView/OrderAttachmentsView';

export const Route = createFileRoute('/_order/orders/$orderGuid/attachments')({
  component: OrderAttachmentsView,
});
